<script>
  export default {
    name: 'DashboardSelector',

    created() {
      this.redirect()
    },

    activated() {
      this.redirect(true)
    },

    methods: {
      redirect(initial) {
        let domain = parseInt(this.$user.$.domain)
        let isFusion = +this.$user.$.data.IsFusion
        const userPermissions = this.$user.$.userPermissions
        const commerceModules = this.$user.$.modules && this.$user.$.modules.Commerce || {}

        if (
          initial &&
          this.$routerHistory.hasHistory() === '/d/Dashboard/My' &&
          (
            (userPermissions.length === 1 && userPermissions.includes('EvedPayCardUser')) ||
            (userPermissions.length === 2 && userPermissions.includes('EvedPayCardUser') && userPermissions.includes('Reports'))
          ) &&
          commerceModules['EvedPay Cards']
        ) {
          this.$router.replace('/d/Programs/>Card/')
          return
        }

        if (domain === 1) {
          if (isFusion === 0) {
            this.$router.replace('/i/Dashboard/MyDashboard')
          } else {
            this.$router.replace('/d/Dashboard/MyDashboard')
          }
        } else {
          if (domain !== null && typeof domain !== 'undefined') {
            this.$router.replace('/i/Dashboard')
          } else {
            global.app.$user.logout()
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/DashboardWrapper/index.vue